import { All_COHORTS } from '@bridebook/toolbox/src/ab-testing/lib/constants';
import { getExperimentCohort } from '@bridebook/toolbox/src/ab-testing/lib/get-experiment-cohort';
import type { Cohort, CohortNames, Experiment } from '@bridebook/toolbox/src/ab-testing/lib/types';
import { getCurrentUserId } from '@bridebook/web/lib/users/selectors';
import { useSelector } from '@bridebook/web/lib/utils';

// Kept from the original A/B test to preserve cohort assignment continuity for existing users.
const ENQUIRY_MESSAGE_TEST_ID = 'LIVE-22479_RandomiseEnquiryMessage';
const NO_OF_RANDOMIZED_MESSAGES = All_COHORTS.length;

const split = 100 / NO_OF_RANDOMIZED_MESSAGES;
const cohorts: Cohort[] = All_COHORTS.map((name, i) => ({
  name,
  allocation: [[i * split, (i + 1) * split]] as [number, number][],
}));

const enquiryMessageExperiment: Experiment = {
  id: ENQUIRY_MESSAGE_TEST_ID,
  name: ENQUIRY_MESSAGE_TEST_ID,
  cohorts,
};

/**
 * Returns the enquiry message variant for a given userId. Falls back to 'control' when userId
 * is empty. Use this in non-React contexts (e.g. Redux epics).
 */
export const getEnquiryMessageVariant = (userId?: string): CohortNames =>
  userId ? getExperimentCohort(enquiryMessageExperiment, userId) : 'control';

/**
 * Returns the enquiry message variant for the current user. Each user is deterministically
 * assigned one of NO_OF_RANDOMIZED_MESSAGES cohorts with equal split, keyed by userId — no A/B
 * test activation needed.
 */
export const useEnquiryMessageVariant = (): CohortNames => {
  const userId = useSelector(getCurrentUserId);
  return getEnquiryMessageVariant(userId);
};
